import { PropsWithChildren, JSX } from 'react';
import classNames from 'classnames';
import { CheckIcon } from '@bg-components/Icon';
import { ListItem } from '../ListItem';
import classes from './SelectListItem.module.scss';

interface IProps {
    selected: boolean;
    label: string;
    onClick(): void;
    dataQa?: string;
}

export const SelectListItem = (props: PropsWithChildren<IProps>): JSX.Element => (
    <ListItem
        className={classNames({
            [classes.selected]: props.selected,
        })}
        onClick={props.onClick}
        dataQa={props.dataQa}
        label={
            <span className={classes.label}>
                <CheckIcon className={classes.icon} />
                <span className={classes.text}>{props.label}</span>
            </span>
        }
    >
        {props.children}
    </ListItem>
);
